import BannerWrapper from './components/bannerWrapper';

const bannerComponent = new BannerWrapper();
bannerComponent.onLoad();
